/**
 * Metadatos (bandera, nombre y color) por OU raíz. Es el mapa fijo del demo (ShineTogetherHomePage.tsx :
 * 497-502), que es también el de la maqueta de «Horarios y Fechas por País»; se comparte entre la gráfica de
 * nominaciones por OU y la tabla de horarios para que no haya dos fuentes de verdad.
 *
 * Las OUs que el mapa no contempla (CENTRAL, FOSE…) no inventan una bandera: usan el globo genérico y su
 * propio nombre.
 */
export interface OuMeta {
  label: string;
  flag: string;
  color: string;
}

export const OU_META: Record<string, OuMeta> = {
  'México': { label: 'México', flag: '🇲🇽', color: '#F08521' },
  'Europa': { label: 'Europa', flag: '🇪🇺', color: '#342F82' },
  'Latam': { label: 'LATAM', flag: '🌎', color: '#20B15A' },
  'USA': { label: 'USA', flag: '🇺🇸', color: '#40B8E9' },
};

export const OU_FLAG_GENERICA = '🌐';

/** Minúsculas y sin acentos: el catálogo de OUs trae «MEXICO» y el mapa «México». */
export function normalizarNombreOu(nombre: string): string {
  return nombre.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
}

const POR_NOMBRE_NORMALIZADO: Record<string, OuMeta> = Object.fromEntries(
  Object.entries(OU_META).map(([clave, meta]) => [normalizarNombreOu(clave), meta]),
);

/** Bandera y nombre para pintar una OU raíz, tolerante a mayúsculas y acentos. */
export function metaDeOu(nombre: string): OuMeta {
  return POR_NOMBRE_NORMALIZADO[normalizarNombreOu(nombre)]
    ?? { label: nombre, flag: OU_FLAG_GENERICA, color: '#888' };
}
